<template>
    <transition name="modal">
        <div>
            <div class="modal-mask">
                <div class="modal-wrapper" @click="$emit('close')">
                    <div class="modal-container" @click.stop="">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content" :class='{isTpg: isTpg}'>
                                <div class="modal-title" style="margin-bottom:30px;">
                                    <span>Add Address</span>
                                    <div class="close-modal" @click="$emit('close')" :class='{isTpg: isTpg}'>
                                        <font-awesome-icon icon="times" aria-hidden="false" />
                                    </div>
                                </div>
                                <form method="post" id="add_address_form" enctype="multipart/form-data" @submit.prevent="submitForm" class="" :class="{isTpg:isTpg}" name="zone_form" style="margin-bottom: 0px;height:auto;min-height:auto;">
                                    <div class="onboarding-container" style="margin-bottom: 0px;height:auto;min-height:auto;">

                                        <reload-page v-if="showReload" :showReloadMessage="showReloadMessage" style="margin-top:50px;" id="reload-component"></reload-page>

                                        <div class="form-group workspace-content-form-row row">
                                            <div class="col-lg-4" :class="{inlineError:v$.address_1.$error,isTpg:isTpg}" id="address_label">
                                                Address:
                                            </div>
                                            <div class="col-lg-8">
                                                <input type="text" name="Address 1" id="address_1" v-model="address_1" data-address_1>
                                            </div>
                                        </div>

                                        <div class="form-group workspace-content-form-row row">
                                            <div class="col-lg-4">
                                                Address 2:
                                            </div>
                                            <div class="col-lg-8">
                                                <input type="text" name="Address 2" id="address_2" v-model="address_2" data-address2>
                                            </div>
                                        </div>

                                        <div class="form-group workspace-content-form-row row">
                                            <div class="col-lg-4" :class="{inlineError:v$.city.$error,isTpg:isTpg}" id="city_label">
                                                City:
                                            </div>
                                            <div class="col-lg-8">
                                                <input type="text" name="City" v-model="city" id="city" data-city>
                                            </div>
                                        </div>

                                        <div class="form-group workspace-content-form-row row">
                                            <div class="col-lg-4" :class="{inlineError:v$.country.$error,isTpg:isTpg}" id="country_label">
                                                Country:
                                            </div>
                                            <div class="col-lg-8">
                                                <vue-select class="style-chooser" close-on-select v-model="country" autocomplete="false" name="Country" id="country" :options="countries" label-by="name" data-country>
                                                </vue-select>
                                            </div>
                                        </div>

                                        <div class="form-group workspace-content-form-row row" v-if="shouldDisplayStates">
                                            <div class="col-lg-4" :class="{inlineError:v$.state.$error,isTpg:isTpg}" id="state_label">
                                                State/Prov:
                                            </div>
                                            <div class="col-lg-8">
                                                <vue-select close-on-select name="State" autocomplete="false" v-model="state" :options="statesOrProvinces" label-by="name" id="state" data-state></vue-select>
                                            </div>
                                        </div>

                                        <div class="form-group workspace-content-form-row row">
                                            <div class="col-lg-4" :class="{inlineError:v$.postal.$error,isTpg:isTpg}" id="postal_label">
                                                Postal:
                                            </div>
                                            <div class="col-lg-8">
                                                <input type="text" name="Postal" v-model="postal" id="postal" data-postal>
                                            </div>
                                        </div>

                                        <div style="width:100%;text-align: center;margin-top:40px;margin-bottom:20px">
                                            <button class="form-submit-button clean-grayv" type="submit" style="width:300px;" :disabled="formHasBeenSubmitted">Submit</button>
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, helpers, requiredIf } from '@vuelidate/validators';

const Querystring = require('querystring');

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      showReload: false,
      showReloadMessage: '',
      address_1: '',
      address_2: '',
      city: '',
      state: null,
      country: null,
      postal: '',
      statesAndProvinces: [],
      countries: [],
      errorString: '',
      statesOrProvinces: [],
      formHasBeenSubmitted: false,
    };
  },
  validations() {
    return {
      address_1: { required: helpers.withMessage('Address is required', required) },
      city: { required: helpers.withMessage('City is required', required) },
      postal: { required: helpers.withMessage('postal is required', required) },
      country: { required: helpers.withMessage('Country is required', required) },
      state: {
        required: helpers.withMessage('State/province is required', requiredIf(function () {
          return (this.country.country_id == '1' || this.country.country_id == '42');
        })),
      },
    };
  },
  mounted() {
    this.setStatesAndCountries();
  },
  props: ['is-tpg', 'category-id', 'location-id', 'account-id'],
  inject: ['cwGlobal'],
  methods: {
    show() {
      // this.clearInfo();
    },
    setStatesAndCountries() {
      const json = this.cwGlobal;
      // const json = require('json-loader!../../cw.json');
      this.statesAndProvinces = json.states;
      this.countries = json.countries;

      this.setDefaultCountry();
    },
    setDefaultCountry() {
      this.$nextTick(function () {
        this.country = this.countries[0];
      });
    },
    submitForm() {
      this.formHasBeenSubmitted = true;
      this.v$.$validate();
      this.errorString = '';
      if (!this.v$.$error) {
        this.saveAddress();
      } else {
        this.formHasBeenSubmitted = false;
        const errors = this.v$.$errors;
        let errorList = '<b>Errors</b><ul>';
        for (let i = 0; i < errors.length; i++) {
          errorList += `<li>${errors[i].$message}</li>`;
        }

        errorList += '</ul>';
        try {
          self.$wkToast(errorList);
        } catch (error) { console.log(''); }
      }
    },
    saveAddress() {
      if (!this.accountId || !this.locationId) {
        this.showReload = true;
        this.showReloadMessage = 'AAM3: Unable to save address';
        return;
      }

      // TODO: check all params before send
      const address = {
        'relations[0][type]': 'Location',
        'relations[0][id]': this.locationId,
      };

      if (this.address_1) {
        address.address_1 = this.address_1;
      }

      if (this.address_2) {
        address.address_2 = this.address_2;
      }

      if (this.city) {
        address.city = this.city;
      }

      if (this.country) {
        address.country_id = this.country.country_id;
      }

      if (this.postal) {
        address.postal = this.postal;
      }

      // Include state id if US or CA
      if (this.country.country_id == '1' || this.country.country_id == '42') {
        address.state_id = this.state.state_id;
      }

      const self = this;
      const addressQueryString = Querystring.stringify(address);

      this.$http.post('/v2/address', addressQueryString).then((response) => {
        if (response.data.error == true) {
          self.errorString = self.returnFriendlyErrors(response);
          try {
            self.$wkToast(self.errorString);
          } catch (error) { console.log(''); }
        } else {
          // Successful POST
          const address_id = response.data.data.address.id;
          address.id = address_id;
          address.category_id = self.categoryId;
          let stateString = '';
          let cityString = '';
          let addressString = '';

          if (self.state && self.state.abbreviation) {
            stateString = ` ${self.state.abbreviation}`;
          }
          if (self.city) {
            cityString = self.city;
          }
          if (self.address_1) {
            addressString = self.address_1.substring(0, 25);
          }
          address.display_name = `${addressString}, ${cityString}${stateString}`;

          self.$emit('addAddress', address);
          self.$emit('close');
        }
      },
      (response) => {
        self.formHasBeenSubmitted = false;

        const element = document.getElementById('add_address_form');
        if (!element) return;
        const top = element.offsetTop + 20;
        window.scrollTo(0, top);

        const responseErrors = self.returnFriendlyErrors(response);
        self.errorString = `2: Error saving address ${responseErrors}`;
        self.$wkToast(self.errorString);
      }).catch((response) => {
        self.formHasBeenSubmitted = false;
        if (!response) {
          // console.log("ww" + JSON.stringify(response));
        } else if (response && response.data) {
          if (response.data.success) {
            let stateString = '';
            let cityString = '';
            let addressString = '';
            address.id = response.data.data.address.id;
            address.category_id = self.category_id;
            if (self.state && self.state.abbreviation) {
              stateString = ` ${self.state.abbreviation}`;
            }
            if (self.city) {
              cityString = self.city;
            }
            if (self.address_1) {
              addressString = self.address_1.substring(0, 25);
            }
            address.display_name = `${addressString}, ${cityString}${stateString}`;

            self.$emit('addAddress', address);
            self.$emit('close');
          } else {
            const responseErrors = self.returnFriendlyErrors(response);
            self.errorString = `3: ${responseErrors}`;
            self.$wkToast(self.errorString);
          }
        }
      });
    },
    clearInfo() {
      this.address_1 = '';
      this.address_2 = '';
      this.city = '';
      this.state = null;
      this.country = null;
      this.postal = '';
      this.errorString = '';
      this.showReload = false;
      this.showReloadMessage = '';
      this.formHasBeenSubmitted = false;
    },
    updateStatesOrProvinces() {
      this.state = null;
      if (this.country && this.country.country_id == '1') {
        const usaStates = [];
        for (var i = 0; i < this.statesAndProvinces.length; i++) {
          if (this.statesAndProvinces[i].country_id == '1') {
            usaStates.push(this.statesAndProvinces[i]);
          }
        }

        this.statesOrProvinces = usaStates;
      } else if (this.country && this.country.country_id == '42') {
        let caProvinces = [];
        for (i = 0; i < this.statesAndProvinces.length; i++) {
          if (this.statesAndProvinces[i].country_id == '42') {
            caProvinces.push(this.statesAndProvinces[i]);
          }
        }

        caProvinces = sortByKey(caProvinces, 'name');
        this.statesOrProvinces = caProvinces;
      }
    },
  },
  computed: {
    shouldDisplayStates() {
      if (this.country && (this.country.country_id == '1' || this.country.country_id == '42')) {
        return true;
      }
      return false;
    },
  },
  watch: {
    country() {
      this.updateStatesOrProvinces();
    },
  },
};

function sortByKey(array, key) {
  return array.sort((a, b) => {
    const x = a[key];
    const y = b[key];
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  });
}
</script>

<style scoped>
.modal-dialog {
    width: auto;
    max-width: 700px;
    margin: 0 auto;
    margin-top: 50px;
}

.modal-content {
    /* width:700px;
        margin:0 auto; */
    background: #666;
    color: white;
}

.modal-content.isTpg {
    background-color: #efefef;
    color: #3a3a3a;
}

.onboarding-container {
    text-align: left;
}

.onboarding-container input[type="text"] {
    border: 0px solid #ccc;
    background: #fff;
    color: #000;
    border-radius: 5px;
    width: 100%;
    height: 36px;
    font-weight: normal;
}
.close-modal {
  position: absolute;
  top: 0px;
  right: 10px;
  cursor: pointer;
  text-align: right;
  width:20px;
  height:20px;
}
.close-modal.isTpg {
    color: black;
}
.style-chooser .vs__search::placeholder,
.style-chooser .vs__dropdown-toggle,
.style-chooser .vs__dropdown-menu {
  background: #dfe5fb;
  border: none;
  color: #394066;
  text-transform: lowercase;
  font-variant: small-caps;
}

.style-chooser .vs__clear,
.style-chooser .vs__open-indicator {
  fill: #394066;
}
.vue-select.style-chooser.vue-dropdown-item {
    background: pink;
}
</style>
